import { Tooltip as MuiTooltip } from '@material-ui/core';
import type { TooltipProps as MuiTooltipProps } from '@material-ui/core';
import React from 'react';
import useTooltip from './useTooltip';

type TooltipProps = Readonly<{
  ariaMode?: 'describedby' | 'labelledby';
  children: React.ReactElement;
  classes?: Partial<Record<string, string>>;
  hasArrow?: boolean;
  isDisabled?: boolean;
  leaveDelay?: number;
  placement?: MuiTooltipProps['placement'];
  title: React.ReactNode;
}>;

function Tooltip({
  ariaMode = 'describedby',
  children,
  classes = {},
  hasArrow = false,
  isDisabled = false,
  leaveDelay = 0,
  placement = 'top',
  title,
}: TooltipProps): JSX.Element {
  const { handleClose, handleOpen, hasContent, isOpen } = useTooltip({ isDisabled, title });

  const isLabelledBy = ariaMode === 'labelledby';

  const child = (hasContent && isLabelledBy && typeof title === 'string')
    ? React.cloneElement(children, { 'aria-label': title })
    : children;

  return (
    <MuiTooltip
      arrow={hasArrow}
      classes={classes}
      interactive
      leaveDelay={leaveDelay}
      onClose={handleClose}
      onOpen={handleOpen}
      open={isOpen}
      placement={placement}
      title={hasContent ? title : ''}
    >
      {child}
    </MuiTooltip>
  );
}

export default Tooltip;
